import React, { useEffect, useState } from 'react';
import './styles.scoped.scss';
import { useLocation } from 'react-router-dom';
import RequestForm from '../RequestForm';
import ResponseDisplay from '../ResponseDisplay';
import RequestMenu from '../RequestMenu';
import RequestBody from '../RequestBody';
import {
  dummyData,
  resolveCallType,
  idFromUrl,
  queryParamFromUrl,
  taxonomyKeyFromUrl,
  taxonomyItemIdFromUrl,
} from '../../../../../services/dummy';
import { notification } from '../../../../../assets/constants/strings';
import {
  getWebApiDocGlossaryById,
  getWebApiDocumentById,
  getWebApiDocuments,
  getWebApiDocumentsByTitle,
  getWebApiSectionsByTitle,
  getWebApiGlossaryByTitle,
  getWebApiSearch,
  getWebApiGetRelatedSectionsId,
  getWebApiRelateDocsById,
  getWebApiSectionByDocId,
  getWebApiSectionsById,
  getWebApiSummaryByDocId,
  queryWebApiDocuments,
  getWebApiMyQueries,
  compareWebApiDocuments,
  getWebApiRelatedContentByDoc,
  getWebApiRelatedContentByTaxonomyItem,
  getWebApiTaxonomies,
  getWebApiTaxonomyItems,
  getWebApiTaxonomyItem,
  getWebApiTaxonomyItemDocuments,
} from '../../../../../store/WebApi/webApiActions';
import { connect } from 'react-redux';

const mapDispatchToProps = {
  getWebApiDocGlossaryById,
  getWebApiDocumentById,
  getWebApiDocuments,
  getWebApiDocumentsByTitle,
  getWebApiSectionsByTitle,
  getWebApiGlossaryByTitle,
  getWebApiSearch,
  getWebApiGetRelatedSectionsId,
  getWebApiRelateDocsById,
  getWebApiSectionByDocId,
  getWebApiSectionsById,
  getWebApiSummaryByDocId,
  queryWebApiDocuments,
  getWebApiMyQueries,
  compareWebApiDocuments,
  getWebApiRelatedContentByDoc,
  getWebApiRelatedContentByTaxonomyItem,
  getWebApiTaxonomies,
  getWebApiTaxonomyItems,
  getWebApiTaxonomyItem,
  getWebApiTaxonomyItemDocuments,
};

const connector = connect(null, mapDispatchToProps);

const Explorer = ({
  getWebApiDocGlossaryById,
  getWebApiDocumentById,
  getWebApiDocuments,
  getWebApiDocumentsByTitle,
  getWebApiSectionsByTitle,
  getWebApiGlossaryByTitle,
  getWebApiSearch,
  getWebApiGetRelatedSectionsId,
  getWebApiRelateDocsById,
  getWebApiSectionByDocId,
  getWebApiSectionsById,
  getWebApiSummaryByDocId,
  queryWebApiDocuments,
  getWebApiMyQueries,
  compareWebApiDocuments,
  getWebApiRelatedContentByDoc,
  getWebApiRelatedContentByTaxonomyItem,
  getWebApiTaxonomies,
  getWebApiTaxonomyItems,
  getWebApiTaxonomyItem,
  getWebApiTaxonomyItemDocuments,
}) => {
  const [response, setResponse] = useState(null);
  const [header, setHeader] = useState(null);
  const [jsonInput, setJsonInput] = useState('');
  const [headers, setHeaders] = useState([]);
  const [apiKey, setApiKey] = useState('');
  const [data, setData] = useState(null);
  const [url, setUrl] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  // Outcome of the last request: { ok, message, durationMs, method, url }
  const [meta, setMeta] = useState(null);

  // Pre-select an endpoint so the page is one click away from a result:
  // ?endpoint=<type> (the docs' "Try it" deep link) wins, else the first one.
  const location = useLocation();
  useEffect(() => {
    const requested = new URLSearchParams(location.search).get('endpoint');
    const preset =
      dummyData.find((item) => item.type === requested) || dummyData[0];
    if (preset) {
      setUrl(preset.endpoint);
      setType(preset.type);
    }
  }, []);

  const handleApiRequest = async (config) => {
    const apiCall = resolveCallType(config?.url) || config?.type;

    if (!apiCall) {
      notification(
        'info',
        'Unknown endpoint.',
        'Pick a request from the menu on the left, or use one of the documented /api/v1 routes.'
      );
      return;
    }

    setLoading(true);
    const startedAt = performance.now();

    const version = 1;
    const docId = idFromUrl(config.url);
    let res = null;

    try {
      switch (apiCall) {
        case 'getDocuments':
          res = await getWebApiDocuments(version);
          break;
        case 'getDocByID':
          res = await getWebApiDocumentById(version, docId);
          break;
        case 'getDocByTitle':
          res = await getWebApiDocumentsByTitle(
            version,
            queryParamFromUrl(config.url, 'title')
          );
          break;
        case 'getSectionsByTitle':
          res = await getWebApiSectionsByTitle(
            version,
            queryParamFromUrl(config.url, 'documentId'),
            queryParamFromUrl(config.url, 'title')
          );
          break;
        case 'getGlossaryByTitle':
          res = await getWebApiGlossaryByTitle(
            version,
            queryParamFromUrl(config.url, 'title')
          );
          break;
        case 'search':
          res = await getWebApiSearch(version, queryParamFromUrl(config.url, 'q'));
          break;
        case 'queryDocuments': {
          let bodyObj;
          try {
            bodyObj =
              config.body && typeof config.body === 'object'
                ? config.body
                : config.body
                ? JSON.parse(config.body)
                : {};
          } catch (e) {
            notification(
              'info',
              'Invalid JSON body',
              'Check the Body tab — it must be valid JSON, e.g. { "query": "…", "documentIds": ["…"] }.'
            );
            setLoading(false);
            return;
          }
          res = await queryWebApiDocuments(version, bodyObj);
          break;
        }
        case 'getMyApiQueries':
          res = await getWebApiMyQueries(
            version,
            queryParamFromUrl(config.url, 'take')
          );
          break;
        case 'compareDocuments': {
          let bodyObj;
          try {
            bodyObj =
              config.body && typeof config.body === 'object'
                ? config.body
                : config.body
                ? JSON.parse(config.body)
                : {};
          } catch (e) {
            notification(
              'info',
              'Invalid JSON body',
              'Check the Body tab — it must be valid JSON with documentId1, documentId2, versionDate1, versionDate2.'
            );
            setLoading(false);
            return;
          }
          res = await compareWebApiDocuments(version, bodyObj);
          break;
        }
        case 'getRelatedContentByDocument':
          res = await getWebApiRelatedContentByDoc(version, docId);
          break;
        case 'getRelatedContentByTaxonomyItem':
          res = await getWebApiRelatedContentByTaxonomyItem(
            version,
            queryParamFromUrl(config.url, 'taxonomy'),
            queryParamFromUrl(config.url, 'itemId')
          );
          break;
        case 'getSectionsByID':
          res = await getWebApiSectionsById(version, docId);
          break;
        case 'getRelatedDocumentsByDocID':
          res = await getWebApiRelateDocsById(version, docId);
          break;
        case 'getGlossaryByDocId':
          res = await getWebApiDocGlossaryById(version, docId);
          break;
        case 'getSectionByPageID':
          res = await getWebApiSectionByDocId(version, docId);
          break;
        case 'getRelatedSectionsByPageID':
          res = await getWebApiGetRelatedSectionsId(version, docId);
          break;
        case 'getSummaryByDocID':
          res = await getWebApiSummaryByDocId(version, docId);
          break;
        case 'getTaxonomies':
          res = await getWebApiTaxonomies(version);
          break;
        case 'getTaxonomyItems':
          res = await getWebApiTaxonomyItems(
            version,
            taxonomyKeyFromUrl(config.url)
          );
          break;
        case 'getTaxonomyItem':
          res = await getWebApiTaxonomyItem(
            version,
            taxonomyKeyFromUrl(config.url),
            taxonomyItemIdFromUrl(config.url)
          );
          break;
        case 'getTaxonomyItemDocuments':
          res = await getWebApiTaxonomyItemDocuments(
            version,
            taxonomyKeyFromUrl(config.url),
            taxonomyItemIdFromUrl(config.url)
          );
          break;
        default:
          break;
      }

      setResponse(res);

      // The service layer unwraps to the API's Response<T> and returns [] / undefined
      // when the request itself failed. Error envelopes come back PascalCase
      // ({ Succeeded:false, Message }), so check both casings. A few endpoints still
      // pass through the raw WordPress envelope ({ status, success, failed }), so treat
      // its failure markers (success:0 or a 4xx/5xx status) as a failure too.
      const ok = res
        ? res.succeeded !== false &&
          res.Succeeded !== false &&
          res.success !== 0 &&
          res.Success !== 0 &&
          !(typeof res.status === 'number' && res.status >= 400) &&
          !(Array.isArray(res) && res.length === 0) &&
          // A leaked axios Error object (has stack/config) is a failure, not a result.
          !(res.stack || res.config)
        : false;
      setMeta({
        ok,
        message: ok
          ? 'Success'
          : (res && (res.message || res.Message)) || 'Request failed',
        durationMs: Math.round(performance.now() - startedAt),
        method: config.method || 'GET',
        url: config.url,
      });
    } finally {
      // never strand the loader, whatever the request did
      setLoading(false);
    }
  };

  const handleBody = ({ headers, jsonInput, apiKey, data, url, type }) => {
    setHeaders(headers);
    setJsonInput(jsonInput);
    setApiKey(apiKey);
    setData(data);
    if (url !== undefined) setUrl(url);
    if (type !== undefined) setType(type);
  };

  // Picking a new endpoint from the menu drops the previous response so the
  // panel never shows a stale result under a different request.
  const selectRequest = (payload) => {
    setResponse(null);
    setHeader(null);
    setMeta(null);
    handleBody(payload);
  };

  // Postman-style workbench: sidebar of requests on the left; the right column
  // stacks URL bar -> request details -> response, with the response panel
  // growing to fill ALL remaining viewport height (no dead space, no response
  // squeezed against the footer).
  return (
    <div className='playground'>
      <aside className='playground__sidebar'>
        <RequestMenu
          selectedUrl={url}
          setRequest={({ headers, jsonInput, apiKey, data, url, type }) =>
            selectRequest({ headers, jsonInput, apiKey, data, url, type })
          }
        />
      </aside>
      <section className='playground__main'>
        <RequestForm
          loading={loading}
          handleApiRequest={handleApiRequest}
          data={data}
          jsonInput={jsonInput}
          apiKey={apiKey}
          headers={headers}
          url={url}
          setUrl={setUrl}
          type={type}
        />

        <RequestBody handleBody={handleBody} url={url} setUrl={setUrl} />

        <div className='playground__response'>
          {/* The panel stays mounted; loading renders INSIDE it. */}
          <ResponseDisplay
            responseData={response}
            responseHeaders={header}
            meta={meta}
            loading={loading}
          />
        </div>
      </section>
    </div>
  );
};

export default connector(Explorer);
